module.exports = __webpack_public_path__ + "static/axo_burgerbeteiligung_mobilitat_mini-51e70c2d3d32427cb284448b479507be.png";